import _ from 'lodash';
import { actions, setIterations } from '../actions';
import { DateSelectionChanged } from '../callers';
import { selectedIterationPeriodSelector } from '../selectors/iterations-picker';
import { isIterationsPeriodKeySelectedSelector } from '../selectors/ui-state';
import AppRouter from 'common/AppRouter';

function isSelectedPeriodVisibleInCurrentRoute(iterations, state) {
  const iterationsById = _.keyBy(iterations, 'id');

  const selectedPeriod = selectedIterationPeriodSelector(state);

  return (
    selectedPeriod &&
    _.get(iterationsById, `[${selectedPeriod.id}].isVisible`, false)
  );
}

const isChangeToLastIteration = (pathname, state) => {
  const isIterationsPeriodKeySelected =
    isIterationsPeriodKeySelectedSelector(state);
  const isDashboard =
    pathname === AppRouter.ROOT.path || AppRouter.PAGE_DASHBOARD.path;

  return (isDashboard && isIterationsPeriodKeySelected) || !isDashboard;
};

const iterationRouteSetter = store => next => action => {
  const state = store.getState();
  const { iterations } = state;
  const {
    payload: { location: { pathname = '' } = {}, dateSelectionCb } = {}
  } = action;

  switch (action.type) {
    case actions.ROUTE_CHANGED:
      switch (pathname) {
        case AppRouter.ROOT.path:
        case AppRouter.PAGE_DASHBOARD.path:
        case AppRouter.CONTRIBUTORS.path:
          const nonComputedIterations = iterations.map(i => ({
            ...i,
            isVisible: !i.isComputed,
            isPostRouteSetter: true
          }));

          store.dispatch(setIterations(nonComputedIterations));

          const isChangeToLastIterationByRoute = isChangeToLastIteration(
            pathname,
            state
          );

          if (
            !isSelectedPeriodVisibleInCurrentRoute(
              nonComputedIterations,
              state
            ) &&
            !dateSelectionCb &&
            isChangeToLastIterationByRoute
          ) {
            const firstIteration = nonComputedIterations.filter(
              i => !i.isComputed
            )[0];
            if (firstIteration) {
              DateSelectionChanged(firstIteration)(store.dispatch);
            }
          }

          if (dateSelectionCb) {
            dateSelectionCb(nonComputedIterations);
          }

          break;

        default:
          const newIterations = iterations.map(i => ({
            ...i,
            isVisible: true,
            isPostRouteSetter: true
          }));

          if (dateSelectionCb) {
            dateSelectionCb(newIterations);
          }

          store.dispatch(setIterations(newIterations));
          break;
      }
      break;
    default: {
    }
  }

  return next(action);
};

export default iterationRouteSetter;
